export default function capitalizeParagraph(paragraph) {
    if (!paragraph) return "";
    if (typeof paragraph !== "string") return "";
    if (paragraph.trim() === "") return "";
    if (paragraph.length === 1) return paragraph.toUpperCase();

    const words = paragraph.split(" ");

    const capitalizedWords = words.map((word) => {
        const capitalizedFirstLetter = word.charAt(0).toUpperCase();
        const restOfWord = word.slice(1);
        return capitalizedFirstLetter + restOfWord;
    });

    return capitalizedWords.join(" ");
}